module.exports = __webpack_public_path__ + "img/huabei.ed9335f8.png";